import { getElementStatsByIdentifier } from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { IFixtureAllStat } from "core-integration/src/store/fixtures/types";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../../../../contexts/PlosTranslationsContext";
import {
  scrollContainer,
  visuallyHidden,
} from "../../../../../styles/utils.css";
import {
  getElementStatNames,
  getStatAbbr,
} from "../../../../../utils/elementStats";
import { InfoText } from "../../../../tooltips/InfoText";
import PlayerStatsRow from "./PlayerStatsRow";
import {
  playerColStyles,
  playerStatsTableStyles,
  statColStyles,
  statusColStyles,
} from "./playerStatsTable.css";
import SkeletonRow from "./SkeletonRow";

interface PlayerStatsTableProps {
  stats: IFixtureAllStat[];
}

const PlayerStatsTable = ({ stats }: PlayerStatsTableProps) => {
  const { playerStats, pointsAbbreviation, status, player, points } =
    usePlosTranslations();
  const statsByName: Record<string, IElementStat> = useSelector(
    getElementStatsByIdentifier,
  );
  const statNames = getElementStatNames();
  const numCols = statNames.length + 3; // +3 for player name, status, points
  const isLoading = stats.length === 0;

  return (
    <div className={scrollContainer}>
      <table aria-label={playerStats} className={playerStatsTableStyles}>
        <thead>
          <tr>
            <th scope="col" className={statusColStyles}>
              <span className={visuallyHidden}>{status}</span>
            </th>
            <th scope="col" className={playerColStyles}>
              {player}
            </th>
            <th scope="col" className={statColStyles}>
              <InfoText label={points}>{pointsAbbreviation}</InfoText>
            </th>
            {statNames.map((n) => (
              <th scope="col" key={n} className={statColStyles}>
                <InfoText label={statsByName[n].label}>
                  {getStatAbbr(n, statsByName)}
                </InfoText>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading
            ? Array.from({ length: 5 }, (_, i) => (
                <SkeletonRow key={i} numCols={numCols} />
              ))
            : stats
                .filter((s) => Number(s.minutes) > 0)
                .map((s) => <PlayerStatsRow key={s.element} stat={s} />)}
        </tbody>
      </table>
    </div>
  );
};

export default PlayerStatsTable;
